module.exports = __webpack_public_path__ + "img/coming-soon.080f809f.svg";